import { render, staticRenderFns } from "./GenericWidget.vue?vue&type=template&id=01bd049f&"
import script from "./GenericWidget.vue?vue&type=script&lang=js&"
export * from "./GenericWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports